import React from 'react';

// in order to be used as button component, MUI requires it to accept refs (and the ref must be passed down, not ignored)
export const LinkInBlank = React.forwardRef<HTMLAnchorElement>((props, ref) => {
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    return <a target="_blank" {...props} ref={ref} />;
});
